module.exports = __webpack_public_path__ + "img/sv69on.18fc4ad9.svg";